import { isAccess } from '@module-role/utils';
import {
  Directive,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import { CurrentUserService } from '@services/current-user/current-user.service';
import { RoleTypeData } from '../../interfaces/role-type-data.interface';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { ModelUser } from '@module-user/models/model-user';

@Directive({
  selector: '[appRole]',
  standalone: false
})
export class RoleDirective implements OnDestroy {
  public hasView = false;
  private currentUserSubscription$!: Subscription;
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private _currentUser: CurrentUserService
  ) {}

  @Input() set appRole(config: RoleTypeData) {
    if (!this.hasView) {
      this.currentUserSubscription$ = this._currentUser.currentUser$
        .pipe(filter((user: ModelUser) => !!user))
        .subscribe((user: ModelUser) => {
          const has = isAccess(user, config);
          if (has) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
          } else {
            this.viewContainer.clear();
          }
        });
    }
  }

  ngOnDestroy() {
    this.currentUserSubscription$.unsubscribe();
  }
}
